import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'premium';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  withArrow?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  withArrow = false,
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#06140d]';
  const variants = {
    primary: 'bg-slate-200 hover:bg-white text-slate-950 focus:ring-slate-300 shadow-[0_4px_14px_0_rgba(226,232,240,0.25)] hover:shadow-[0_6px_20px_rgba(226,232,240,0.4)] hover:-translate-y-0.5',
    secondary: 'bg-emerald-800 hover:bg-emerald-700 text-white focus:ring-emerald-500 shadow-lg hover:shadow-xl hover:-translate-y-0.5',
    outline: 'border-2 border-slate-400 hover:border-slate-200 text-slate-200 hover:bg-slate-800/50 focus:ring-slate-300',
    premium: 'bg-gradient-to-r from-slate-300 to-slate-200 hover:from-slate-200 hover:to-white text-slate-900 focus:ring-slate-300 shadow-[0_4px_14px_0_rgba(203,213,225,0.25)] hover:shadow-[0_6px_20px_rgba(203,213,225,0.4)] hover:-translate-y-0.5 border border-slate-300'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  return <motion.button whileTap={{
    scale: 0.98
  }} className={classes} {...props} data-id="element-344">
      {children}
      {withArrow && <ArrowRight className="ml-2 w-5 h-5" data-id="element-345" />}
    </motion.button>;
}